import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { ITheme } from '../../themer';
import { Responsive } from '../../utils';

export interface IBoxProps {
	width?: Responsive.IValueOrResponsiveValue;
}

const getWidth = (width: string) => `width: ${width};`;

export const Box = styled('div', {
	shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'width',
})<IBoxProps, ITheme>`
	${Responsive.getStyles('width', getWidth)}
`;
